import { useEffect } from 'react'
import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'

interface useInitProps {
  setCustomers: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    axiosGet(`${apiUrls.customers}/${apiUrls.actionMyCustomers}`).then((response: any) => {
      if (response?.data) {
        props.setCustomers(response.data)
      }
    })
  }, [])
}

export default useInit
